var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPuzzle3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.733,
    height: 36.733,
    viewBox: "0 0 36.733 36.733",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "puzzle",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M7.981,17.777a1.076,1.076,0,0,1,.086,1.02,1.806,1.806,0,1,0,3.31,0,1.076,1.076,0,0,1,.986-1.507h4.928V13.679h-.076a3.958,3.958,0,1,1,0-7.916h.076V0H3.958A3.962,3.962,0,0,0,0,3.958V17.291H7.08A1.076,1.076,0,0,1,7.981,17.777Z",
    transform: "translate(0 0)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M232.133,0H218.8V7.08a1.076,1.076,0,0,1-1.507.986,1.806,1.806,0,1,0,0,3.31,1.076,1.076,0,0,1,1.507.986V17.29h3.612c0-.025,0-.051,0-.076a3.958,3.958,0,0,1,7.916,0c0,.025,0,.051,0,.076h5.764V3.958A3.962,3.962,0,0,0,232.133,0Z",
    transform: "translate(-199.358)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M21.325,278.569a1.806,1.806,0,0,0-2.528-1.655,1.076,1.076,0,0,1-1.507-.986V271H13.679q0,.038,0,.076a3.958,3.958,0,0,1-7.916,0q0-.038,0-.076H0v13.333a3.962,3.962,0,0,0,3.958,3.958H17.29v-7.08a1.076,1.076,0,0,1,1.507-.986,1.806,1.806,0,0,0,2.528-1.655Z",
    transform: "translate(0 -251.557)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M280.31,218.314a1.076,1.076,0,0,1-.086-1.02,1.806,1.806,0,1,0-3.31,0,1.076,1.076,0,0,1-.986,1.507H271v3.612h.076a3.958,3.958,0,0,1,0,7.916H271v5.764h13.332a3.962,3.962,0,0,0,3.958-3.958V218.8h-7.08a1.076,1.076,0,0,1-.9-.487Z",
    transform: "translate(-251.557 -199.358)",
    fill: "#4e3057"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzle3);
export default __webpack_public_path__ + "static/media/puzzle_3.4fa8854f6c8311c8f2573bcdaaa8930e.svg";
export { ForwardRef as ReactComponent };